// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import { ApiUrls } from '../../utility/ApiUrls'

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

let getUserCall = false
const apiCall = async (method, endpoint, requestPayload) => {
  // console.log(method, endpoint, data)
  const authAxios = DefaultConfig().authAxios
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({ userId: element.id, name: `${element.firstName} ${element.lastName}`, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)


  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDPPReportByDate = createAsyncThunk("appCommonReducers/GetDPPReportByDate", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInspectionDashboardData}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetPSCInspectionStatsForFlags = createAsyncThunk("appCommonReducers/GetPSCInspectionStatsForFlags", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetPSCInspectionStatsForFlags}?year=${wdata.year}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategoriesAndTypes = createAsyncThunk("appCommonReducers/GetCategoriesAndTypes", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCategoriesAndTypes}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategorieTypesDescription = createAsyncThunk("appCommonReducers/GetCategorieTypesDescription", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCategorieTypesDescription}`
  const resultData = await apiCall(method, endpoint, wdata)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserHierarchy = createAsyncThunk("appCommonReducers/GetUserHierarchy", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserHierarchy}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: false,
      tokenExp: false
    }
  }
})


export const GetProfilePicture = createAsyncThunk(
  "appCommonReducers/GetProfilePicture",
  async (email) => {
    try {
      const method = "get"
      const endpoint = `/UserProfile/GetProfilePicture?email=${encodeURIComponent(email)}`
      const resultData = await apiCall(method, endpoint, "")

      // if apiCall already returns string base64 => use it directly
      if (resultData && typeof resultData === "string" && resultData.trim() !== "") {
        return {
          email,
          image: `data:image/jpeg;base64,${resultData}`,
          success: true
        }
      }

      return {
        email,
        image: null,
        success: false
      }
    } catch (error) {
      return {
        email,
        image: null,
        success: false
      }
    }
  }
)

export const CreateOnboardWorkorder = createAsyncThunk(
  "appCommonReducers/CreateOnboardWorkorder",
  async (payload) => {
    const method = 'post'
    const endpoint = 'ONB/CreateWorkorder'
    const resultData = await apiCall(method, endpoint, payload)

    if (resultData) {
      toast(t => (<ToastMessage t={t} message={"Workorder created successfully!"} status={"success"} />))
      return {
        data: resultData,
        spinner: true,
        tokenExp: false
      }
    } else {
      return {
        data: null,
        spinner: true,
        tokenExp: false
      }
    }
  }
)

// Create Offboard Workorder
export const CreateOffboardWorkorder = createAsyncThunk(
  "appCommonReducers/CreateOffboardWorkorder",
  async (payload) => {
    const method = 'post'
    const endpoint = 'OFB/CreateWorkorder'
    const resultData = await apiCall(method, endpoint, payload)

    if (resultData) {
      toast(t => (<ToastMessage t={t} message={"Offboarding workorder created successfully!"} status={"success"} />))
      return {
        data: resultData,
        spinner: true,
        tokenExp: false
      }
    } else {
      return {
        data: null,
        spinner: true,
        tokenExp: false
      }
    }
  }
)

export const GetWorkorderById = createAsyncThunk(
  "appCommonReducers/GetWorkorderById",
  async (workorderId) => {
    console.log("GetWorkorderById - Called with workorderId:", workorderId)
    const method = 'get'
    const endpoint = `ONB/GetWorkorderById?id=${workorderId}`
    console.log("GetWorkorderById - Calling API with endpoint:", endpoint)
    const resultData = await apiCall(method, endpoint)
    console.log("GetWorkorderById - API response:", resultData)

    if (resultData) {
      return {
        data: resultData,
        spinner: true,
        tokenExp: false
      }
    } else {
      return {
        data: null,
        spinner: true,
        tokenExp: false
      }
    }
  }
)

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    usersData: null,
    uspiner: false,
    userRoleData: [],
    urspiner: false,

    vesselReportByDate: [],
    dppReportByDate: [],
    categories: [],
    allroles: [],
    spinner1: false,
    userHierarchy: null,
    hierarchySpinner: false,
    profilePictures: {},
    profileLoading: {}, // object { email: boolean }
    profileError: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetCategoriesAndTypes.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner1 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.categories = action.payload.data
        }
      })

      .addCase(GetDPPReportByDate.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.dppReportByDate = action.payload.data
        }
      })
      .addCase(GetAllRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allroles = action.payload.data
        }
      })
      .addCase(GetUserHierarchy.pending, (state) => {
        state.hierarchySpinner = true
      })
      .addCase(GetUserHierarchy.fulfilled, (state, action) => {
        if (action.payload) {
          state.hierarchySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userHierarchy = action.payload.data
        }
      })
      .addCase(GetUserHierarchy.rejected, (state) => {
        state.hierarchySpinner = false
      })
      .addCase(GetProfilePicture.pending, (state, action) => {
        const email = action.meta.arg
        state.profileLoading[email] = true
        state.profileError = null
      })
      .addCase(GetProfilePicture.fulfilled, (state, action) => {
        const email = action.payload.email
        state.profileLoading[email] = false
        if (action.payload && action.payload.email) {
          const { email, image } = action.payload
          state.profilePictures[email] = image
        }
      })
      .addCase(GetProfilePicture.rejected, (state, action) => {
        const email = action.meta.arg
        state.profileLoading[email] = false
        state.profileError = action.error?.message || "Failed to load profile picture"
      })
  }
})
export const { handleAddtoCart } = commonreducerSlice.actions
export default commonreducerSlice.reducer
